<template>
  <div>
    <v-card>
      <v-card-title>{{ test.name }}</v-card-title>
      <v-card-subtitle
        >You must watch the full video before taking the test</v-card-subtitle
      >
      <v-card-text>
        <video
          v-if="test.videoId"
          :src="video"
          controls
          playsinline
          preload="auto"
          width="100%"
          name="videoPlayer"
          :poster="image"
        ></video>

        <v-btn color="primary darken-2" width="100%" @click="navigate"
          >Take Test
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import TestService from "@/services/TestService.js";
import ApiService from "@/services/ApiService.js";
export default {
  data() {
    return {
      test: {}
    };
  },
  created() {
    this.getTest();
  },
  computed: {
    video() {
      return `${ApiService.getBaseUrl()}test/video/${this.test.videoId}`;
    },
    docs() {
      return `${ApiService.getBaseUrl()}test/docs/${
        this.test.additionalDocsId
      }`;
    },
    image() {
      return `${ApiService.getBaseUrl()}test/thumbnail/${
        this.test.thumbnailId
      }`;
    }
  },
  methods: {
    getTest() {
      TestService.getTest(this.$route.params.testId).then(
        response => (this.test = response)
      );
    },
    navigate() {
      this.$router.push({ name: "Test", params: { testId: this.test.testId } });
    },
    additionalDocs() {
      window.open(this.docs);
    }
  }
};
</script>

<style scoped></style>
